import PropTypes from 'prop-types'
import styled from 'styled-components'

import { useTranslation } from 'react-i18next'

import {
  useFetchHttpResponseCodeCountQuery,
} from 'api/dashboard'

import colors from 'components/utils/colors'
import HttpRequestCodeChartBar from './HttpRequestCodeChartBar'
import LoadingIndicator from 'components/Shared/LoadingIndicator/Index'
import Tooltip from 'components/Shared/Tooltip/Index'
import IconLink from 'components/Shared/IconLink/Index'
import { colorizeResponseCodes } from 'utils/color'

const StyledContent = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: #fff;
  padding: 10px 16px 10px 16px;
  box-sizing: border-box;
  border-radius: 3px;
`
const Title = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: Exo;
  font-size: 14px;
  font-weight: 500;
  padding-bottom: 10px;
  padding-right: 5px;
  color: ${colors.secondary20};
  white-space: nowrap;
`

const ChartsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`

const StyledIconLink = styled(IconLink)`
  padding-left: 10px;
`

const HttpRequestCodeChart = ({ ticketingSystemDisplayId }) => {
  const { t } = useTranslation()

  const { data, isFetching } =
    useFetchHttpResponseCodeCountQuery({
      ticketingSystemDisplayId: ticketingSystemDisplayId,
    })

  const httpRequestCodesCount = data?.httpRequestCodesCount || []

  const tooltipText = t('dashboardPage.httpCodeRequestTooltip')
  const tooltipId = 'http-code-request-tooltip'

  const dataKeys = Object.keys(httpRequestCodesCount)
  let httpRequestCodesData = dataKeys.map(key => ({
    name: key,
    value: httpRequestCodesCount[key],
  }))

  httpRequestCodesData = colorizeResponseCodes(httpRequestCodesData)

  return (
    <StyledContent data-test='http-code-chart'>
      <LoadingIndicator loading={isFetching} small />
      <Title>
        {t('dashboardPage.httpCodeRequest')}
        <StyledIconLink
          data-tooltip-content={tooltipText}
          data-tooltip-id={tooltipId}
          iconName='icon-help-16'
        />
        <Tooltip id='http-code-request-tooltip' />
      </Title>
      <ChartsWrapper>
        <HttpRequestCodeChartBar
          httpRequestCodesCount={httpRequestCodesData}
        />
      </ChartsWrapper>
    </StyledContent>
  )
}

HttpRequestCodeChart.propTypes = {
  ticketingSystemDisplayId: PropTypes.string,
}

export default HttpRequestCodeChart
